export default __webpack_public_path__ + "img/threat-detection.d0695a72.png";